/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ProductSetProductImageById$Params {
  productId: string;
  imageSrc?: string;
}

export function productSetProductImageById(http: HttpClient, rootUrl: string, params: ProductSetProductImageById$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, productSetProductImageById.PATH, 'post');
  if (params) {
    rb.path('productId', params.productId, {});
    rb.query('imageSrc', params.imageSrc, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

productSetProductImageById.PATH = '/api/Product/{productId}/set/image';
